(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.playVideo = (el) => {
    const video = el.querySelector('video');
    if (video) {
      video.play();
    }
  };
  window.pauseVideo = (el) => {
    const video = el.querySelector('video');
    if (video) {
      video.pause();
    }
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    window.closeModal = function (btn) {
  const modal = btn.closest('.modal-container');
  if (!modal) return;

  modal.classList.remove('active');
  document.body.style.overflow = 'auto';
};

  window.addEventListener('click', (e) => {
    document.querySelectorAll('.modal-container.active').forEach((modal) => {
      if (e.target === modal) {
        modal.classList.remove('active');
        document.body.style.overflow = 'auto';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
